// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"02ce5f2a","503":"c5a3e5f6","582":"b960caa9","695":"4d088a5e"}[chunkId] + ".chunk.js";
};